module.exports = __webpack_public_path__ + "static/media/customer-hiw-3.7feaeab9.png";